// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"41b4e8e2","920":"4c753528"}[chunkId] + ".chunk.js";
};